<template>
  <div class="pag-wrap">
    <my-header
        :current-title="['税务数字账户','发票勾选确认','抵扣类勾选']"
        v-bind="$attrs"
    />

    <div class="content-box">
      <div class="title-header">
        <h3>税款所属期：2026年12月</h3>
        <span class="sub">当前可操作发票的开具日期范围2017-01-01至2026-12-31</span>
      </div>

      <el-card style="margin-top: 20px;">
        <el-tabs v-model="activeName">
          <el-tab-pane label="待处理农产品发票" name="待处理农产品发票">
            <el-empty description="暂无内容"/>
          </el-tab-pane>

          <el-tab-pane label="抵扣勾选" name="抵扣勾选">
            <div>
              <el-radio-group v-model="queryParams.cate" size="large">
                <el-radio-button label="发票" value="fp"/>
                <el-radio-button label="海关缴款书" value="hg"/>
                <el-radio-button label="代扣代缴完税凭证" value="dj"/>
              </el-radio-group>

              <el-form :model="queryParams" ref="formRef"
                       inline
                       size="large"
                       :rules="rules" label-width="140px">
                <el-form-item label="勾选状态" prop="checked">
                  <el-select
                      v-model="queryParams.checked"
                      style="width: 190px;"
                      placeholder="请选择">
                    <el-option label="未勾选" value="0"/>
                    <el-option label="已勾选" value="1"/>
                  </el-select>
                </el-form-item>

                <el-form-item label="发票来源" prop="source">
                  <el-select
                      v-model="queryParams.source"
                      style="width: 190px;"
                      placeholder="请选择">
                    <el-option label="全部" value="全部"/>
                  </el-select>
                </el-form-item>

                <el-form-item label="开票日期（起）" prop="startTime">
                  <el-date-picker
                      v-model="queryParams.startTime"
                      placeholder="选择日期"
                      type="date"
                      value-format="YYYY-MM-DD"
                      style="width: 190px"
                  />
                </el-form-item>

                <el-form-item label="开票日期（止）" prop="endTime">
                  <el-date-picker
                      v-model="queryParams.endTime"
                      placeholder="选择日期"
                      type="date"
                      value-format="YYYY-MM-DD"
                      style="width: 190px"
                  />
                </el-form-item>

                <el-form-item label="发票状态" prop="ticStatus">
                  <el-select
                      v-model="queryParams.ticStatus"
                      style="width: 190px;"
                      placeholder="请选择">
                    <el-option label="全部" value="全部"/>
                    <el-option label="正常" value="正常"/>
                    <el-option label="已作废" value="已作废"/>
                    <el-option label="已失控" value="已失控"/>
                    <el-option label="已红冲" value="已红冲"/>
                  </el-select>
                </el-form-item>

                <el-form-item label="票种" prop="invoiceType">
                  <el-select
                      v-model="queryParams.invoiceType"
                      style="width: 190px;"
                      placeholder="请选择">
                    <el-option label="全部" value="全部"/>
                    <el-option label="纸质发票（增值税专用发票）" value="1"/>
                    <el-option label="增值税专用发票" value="2"/>
                    <el-option label="电子发票（增值税专用发票）" value="3"/>
                    <el-option label="增值税电子发票" value="4"/>
                    <el-option label="机动车发票" value="5"/>
                    <el-option label="通行费电子发票" value="6"/>
                    <el-option label="电子发票（铁路电子客票）" value="7"/>
                  </el-select>
                </el-form-item>

                <el-form-item label="销售方纳税人识别号" prop="saleCode">
                  <el-input
                      v-model="queryParams.saleCode"
                      placeholder="请输入"
                      clearable
                      readonly
                      maxlength="50"
                      style="width: 190px;"
                  />
                </el-form-item>

                <el-form-item label="销售方纳税人名称" prop="saleName">
                  <el-input
                      v-model="queryParams.saleName"
                      placeholder="请输入"
                      clearable
                      readonly
                      maxlength="50"
                      style="width: 190px;"
                  />
                </el-form-item>

                <el-form-item label="数电票号码" prop="mathCode">
                  <el-input
                      v-model="queryParams.mathCode"
                      placeholder="请输入"
                      clearable
                      readonly
                      maxlength="50"
                      style="width: 190px;"
                  />
                </el-form-item>

                <el-form-item label="发票代码" prop="ticCode">
                  <el-input
                      v-model="queryParams.ticCode"
                      placeholder="请输入"
                      clearable
                      readonly
                      maxlength="50"
                      style="width: 190px;"
                  />
                </el-form-item>

                <el-form-item label="发票号码" prop="ticNum">
                  <el-input
                      v-model="queryParams.ticNum"
                      placeholder="请输入"
                      clearable
                      readonly
                      maxlength="50"
                      style="width: 190px;"
                  />
                </el-form-item>

                <el-form-item label="发票风险等级" prop="riskLevel">
                  <el-select
                      v-model="queryParams.riskLevel"
                      style="width: 190px;"
                      placeholder="请选择">
                  </el-select>
                </el-form-item>

                <el-form-item label="业务类型" prop="businessType">
                  <el-select
                      v-model="queryParams.businessType"
                      style="width: 190px;"
                      placeholder="请选择">
                  </el-select>
                </el-form-item>

                <el-form-item label="是否为转内销票种" prop="isInner">
                  <el-select
                      style="width: 190px;"
                      placeholder="请选择">
                    <el-option label="是" value="1"/>
                    <el-option label="否" value="0"/>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-button type="info">重置</el-button>
                  <el-button type="primary" @click="queryData(true)">查询</el-button>
                  <el-button icon="ArrowUp">收起</el-button>
                </el-form-item>
              </el-form>

              <div style="display: flex;align-items: center;">
                <el-button
                    size="large"
                    type="primary">清单导入勾选
                </el-button>
                <el-button
                    size="large"
                    type="info">导出
                </el-button>
                <el-button
                    size="large"
                    type="info">代开农产品发票录入
                </el-button>
                <el-button
                    size="large"
                    type="info">全部勾选
                </el-button>

                <div style="flex-grow: 1;"></div>

                <el-button
                    size="large">自定义列
                </el-button>
              </div>

              <el-table
                  ref="tableRef"
                  :data="tableList"
                  style="margin-top: 10px;"
                  border
                  @selection-change="handleTableSelect"
              >
                <el-table-column type="selection" label="勾选" fixed="left" align="center" width="60"/>

                <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

                <el-table-column label="全电发票号码" align="center" fixed="left" prop="allInvoiceNumber" width="160"/>

                <el-table-column label="发票代码" align="center" fixed="left" prop="invoiceCode" width="160"/>

                <el-table-column label="发票号码" align="center" prop="invoiceNumber" width="160"/>

                <el-table-column label="开票日期" align="center" prop="invoiceDate" width="180"/>

                <el-table-column label="销方名称" align="center" prop="sellerName" width="200"/>

                <el-table-column label="销方税号" align="center" prop="sellerCode" width="160"/>

                <el-table-column label="金额" align="center" prop="amount" width="120">
                  <template #default="{row}">
                    <span>{{ row.amount.toFixed(2) }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="税额" align="center" prop="taxAmount" width="120">
                  <template #default="{row}">
                    <span>{{ row.taxAmount.toFixed(2) }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="有效税额" align="center" prop="effectiveTaxAmount" width="120">
                  <template #default="{row}">
                    <span>{{ row.effectiveTaxAmount.toFixed(2) }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="发票状态" align="center" prop="invoiceStatus" width="120"/>

                <el-table-column label="发票类型" align="center" prop="invoiceType" width="140"/>

                <el-table-column label="信息来源" align="center" prop="infoSource" width="80"/>

                <el-table-column label="是否勾选" align="center" prop="checked" width="80">
                  <template #default="{row}">
                    <span v-if="queriedParams.checked == '0'">未勾选</span>
                    <span v-else-if="queriedParams.checked == '1'">已勾选</span>
                  </template>
                </el-table-column>

                <el-table-column label="勾选时间" align="center" prop="checkTime" width="200">
                  <template #default="{row}">
                    <span>2026-12-31 00:00:00</span>
                  </template>
                </el-table-column>

                <el-table-column label="管理状态" align="center" prop="manageStatus" width="80">
                  <template #default="{row}">
                    <span>正常</span>
                  </template>
                </el-table-column>

                <el-table-column label="操作" align="center" prop="score" width="120">
                  <template #default="{row}">
                    <el-button type="danger" link
                               @click="seeDetail(row)"
                    >查看明细信息
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </el-tab-pane>

          <el-tab-pane label="统计确认" name="统计确认">
            <template #label>
              <div class="label-title">
                <span>统计确认</span>
                <div class="status-show" v-if="savedData.verify != '是'">
                  当前未确认
                </div>
              </div>
            </template>
            <div class="statist-wrap">
              <el-steps :active="currentStep" finish-status="success">
                <el-step title="申请统计"/>
                <el-step title="统计完成"/>
                <el-step title="确认"/>
              </el-steps>

              <div v-if="currentStep == 0" class="step0">
                <el-empty description="点击申请统计，查看统计"/>
                <el-button
                    style="margin-top: -20px;"
                    type="primary" size="large"
                    @click="reqStatist"
                >申请统计
                </el-button>
              </div>

              <div v-if="currentStep == 2 || currentStep == 3" class="step2">
                <h3>增值税申报进项抵扣汇总</h3>
                <el-table
                    :data="summaryList"
                    class="summary-ui-table"
                >

                  <el-table-column label="进项抵扣类型" align="left" prop="jxlx" min-width="100"/>

                  <el-table-column label="份数" align="center" prop="fs" width="100"/>

                  <el-table-column label="金额" align="center" prop="je" width="150"/>

                  <el-table-column label="税额" align="center" prop="sx" width="150"/>
                </el-table>

                <h3>抵扣类勾选统计结果</h3>

                <el-table
                    :data="statistResList"
                    class="summary-ui-table"
                >

                  <el-table-column label="发票类型" align="left" prop="fplx" min-width="130"/>

                  <el-table-column label="合计份数" align="center" prop="hjfs" width="100"/>

                  <el-table-column label="有效抵扣税额合计" align="center" prop="yxhj" min-width="130"/>

                  <el-table-column label="出口转内销证明份数" align="center" prop="ckfs" min-width="130"/>

                  <el-table-column label="出口转内销证明有效抵扣税额合计" prop="ckhj" min-width="200"/>

                  <el-table-column label="其他发票份数" align="center" prop="qtfs" width="130"/>

                  <el-table-column label="其他发票有效抵扣税额合计" align="center" prop="qthj" min-width="180"/>
                </el-table>
              </div>

            </div>
          </el-tab-pane>

        </el-tabs>
      </el-card>

      <footer style="display: flex;justify-content: center;padding: 30px 0;">
        <img src="https://static.rhkj.com/renhe_fe/other/333.png">
      </footer>
    </div>

    <div class="bottom" v-if="activeName == '抵扣勾选'">
      <el-button
          v-if="queriedParams.checked == '0'"
          size="large"
          type="primary"
          @click="submit">确认勾选
      </el-button>
      <el-button
          v-if="queriedParams.checked == '1'"
          size="large"
          type="primary"
          @click="revokeSubmit">撤销勾选
      </el-button>
    </div>

    <div class="bottom" v-if="activeName == '统计确认' && [2,3].includes(currentStep)">
      <el-button
          size="large"
          type="info"
      >打印
      </el-button>
      <el-button
          size="large"
          type="info"
      >下载发票明细
      </el-button>
      <el-button
          v-if="currentStep == 2"
          size="large"
          type="info"
          @click="revokeStatist"
      >撤销统计
      </el-button>
      <el-button
          v-if="currentStep == 2"
          size="large"
          type="primary"
          @click="confirmStatist"
      >统计确认
      </el-button>

      <el-button
          v-if="currentStep == 3"
          size="large"
          type="primary"
          @click="revokeConfirm"
      >撤销确认
      </el-button>
    </div>

  </div>
</template>


<script setup lang="jsx">
import myHeader from "./cmp/myHeader.vue";
import {$emit, $on} from "vue-happy-bus";
import {ElMessage, ElMessageBox} from "element-plus";
import Big from "big.js";
import {renderYear} from "@/views/examCenter/taxDigitalAccountV2/taxDigAccLoginHandler.js";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const activeName = ref('抵扣勾选')

const queryParams = reactive({
  cate: 'fp',
  checked: '0',
  source: '全部',
  startTime: '2026-12-01',
  endTime: '2026-12-31',
  ticStatus: '正常',
  invoiceType: '全部',
})

const rules = reactive({
  /*name00x: [
    {required: true, message: '请输入', trigger: 'blur'},
  ],*/
  checked: [
    {required: true, message: '请选择', trigger: 'change'},
  ],
  source: [
    {required: true, message: '请选择', trigger: 'change'},
  ],
  startTime: [
    {required: true, message: '请选择', trigger: 'change'},
  ],
  endTime: [
    {required: true, message: '请选择', trigger: 'change'},
  ],
})

const tableList = ref([])
const tableRef = ref()
const selectRows = ref([])
let queriedParams = ref({}) // 已经查询的查询参数，接口执行后自动赋值
let savedData = ref({ // 已勾选，保存到服务器的列
  checkRows: [],
  verify: '否',
})

function handleTableSelect(rows) {
  selectRows.value = rows
}

// 点击查询
function queryData(byUser) {
  const initialData = JSON.parse(props.currentQa.initialAnswer || "[]")

  initialData.forEach(e => {
    e.invoiceDate = renderYear(e.invoiceDate)
  })

  queriedParams.value = JSON.parse(JSON.stringify(queryParams))
  if (queryParams.checked == '0') { // 未勾选数据查询
    tableList.value = initialData
        .filter(f => !savedData.value.checkRows.some(s => s.invoiceCode === f.invoiceCode));
  } else if (queryParams.checked == '1') {
    tableList.value = savedData.value.checkRows
  }
  /*if (!byUser) {
    return
  }
  ElMessageBox.alert('查询成功', '提示', {
    confirmButtonText: 'OK',
    showClose: false,
    callback: () => {
    },
  })*/
}

// 确认勾选
function submit() {
  const rows = tableRef.value.getSelectionRows()
  if (!rows || rows.length === 0) {
    ElMessage.warning('请先勾选发票!')
    return
  }
  let amountTotal = new Big(0), taxAmountTotal = new Big(0), effectiveTaxAmountTotal = new Big(0)

  rows.forEach(row => {
    amountTotal = amountTotal.plus(row.amount)
    taxAmountTotal = taxAmountTotal.plus(row.taxAmount)
    effectiveTaxAmountTotal = effectiveTaxAmountTotal.plus(row.effectiveTaxAmount)
  })
  const vnode = (
      <div
          style="color:#555555;line-height:22px;letter-spacing: 0.3px;display:flex;flex-direction: column; align-items: center;width:400px;">
        <img style="display:block;width:32px;height:32px;" src="https://static.rhkj.com/renhe_fe/other/334.png"></img>
        <div style="font-size: 20px;">确认勾选</div>
        <div>本次勾选数量{rows.length}</div>
        <div>金额合计{amountTotal.toFixed(2)}</div>
        <div>税额合计{taxAmountTotal.toFixed(2)}</div>
        <br/>
        <div>是否确认提交?</div>
      </div>
  );
  ElMessageBox.alert(vnode, '提示', {
    cancelButtonText: '取消',
    showCancelButton: true,
  })
      .then(() => {
        $emit('exeSaveQa', {type: 1}) //类型1：确认勾选   2撤销勾选
      })
      .catch(() => {
      })
}

// 撤销勾选
function revokeSubmit() {
  const rows = tableRef.value.getSelectionRows()
  if (!rows || rows.length === 0) {
    ElMessage.warning('请先勾选发票!')
    return
  }
  let amountTotal = new Big(0), taxAmountTotal = new Big(0), effectiveTaxAmountTotal = new Big(0)

  rows.forEach(row => {
    amountTotal = amountTotal.plus(row.amount)
    taxAmountTotal = taxAmountTotal.plus(row.taxAmount)
    effectiveTaxAmountTotal = effectiveTaxAmountTotal.plus(row.effectiveTaxAmount)
  })
  const vnode = (
      <div
          style="color:#555555;line-height:22px;letter-spacing: 0.3px;display:flex;flex-direction: column; align-items: center;width:400px;">
        <img style="display:block;width:32px;height:32px;" src="https://static.rhkj.com/renhe_fe/other/334.png"></img>
        <div style="font-size: 20px;">确认撤销</div>
        <div>本次撤销数量{rows.length}</div>
        <div>金额合计{amountTotal.toFixed(2)}</div>
        <div>税额合计{taxAmountTotal.toFixed(2)}</div>
        <br/>
        <div>是否确认提交?</div>
      </div>
  );
  ElMessageBox.alert(vnode, '提示', {
    cancelButtonText: '取消',
    showCancelButton: true,
  })
      .then(() => {
        $emit('exeSaveQa', {type: 2}) //类型1：确认勾选   2撤销勾选
      })
      .catch(() => {
      })
}

// 爷爷组件，保存成功回调
$on('saveQaSuccess', res => {
  if (res.byUser) {
    savedData.value = {
      ...savedData.value,
      ...JSON.parse(res?.serverData?.solution || "{}"),
    }
    switch (res?.serverData.innerQaType) {
      case 3: // 统计确认步骤
        currentStep.value = 3
        ElMessage.success('成功')
        break
      case 4: // 撤销确认
        currentStep.value = 2
        ElMessage.success('撤销成功')
        break
      case 1: //确认勾选、撤销勾选
      case 2:
        ElMessage.success('成功')
        queryData(false)
        break
    }
  }
})

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = (byUser, params) => {
  const rows = tableRef.value && tableRef.value.getSelectionRows() || []
  //类型1：确认勾选   2撤销勾选  3统计确认  4撤销确认
  const checkIn = params.type == 1 ? savedData.value.checkRows.concat(rows) :
      params.type == 2 ? savedData.value.checkRows.filter(f => !rows.some(s => s.invoiceCode == f.invoiceCode)) : savedData.value.checkRows

  const verifyIn = params.type == 3 ? '是' :
      params.type == 4 ? '否' : savedData.value.verify

  return {
    solution: JSON.stringify({
      checkRows: checkIn,
      verify: verifyIn,
    }) || '',
    innerQaType: params.type, // 增加参数，服务端其实没用，以便在成功回调监听到
  }
}
getGrandchildValue.value.fillFinish = () => {
  return savedData.value.verify == '是'
}

onMounted(() => {
  savedData.value = {
    ...savedData.value,
    ...JSON.parse(props.currentQa?.solution || "{}"),
  }
  queryData(false)
  if (savedData.value.verify == '是') { // 已确认
    currentStep.value = 3
    initResDataShow()
  }
})

const currentStep = ref(0)
const summaryList = ref([])
const statistResList = ref([])

function reqStatist() {
  currentStep.value = 2
  initResDataShow()
}

//统计确认，主操作按钮
function confirmStatist() {
  const vnode = (
      <div
          style="color:#555555;line-height:22px;letter-spacing: 0.3px;display:flex;flex-direction: column; align-items: center;">
        <img style="display:block;width:32px;height:32px;" src="https://static.rhkj.com/renhe_fe/other/334.png"></img>
        <div style="font-size: 20px;">统计确认</div>
        <div style="text-align:center;line-height:32px;margin-top:5px;">确认后当前统计报表将为申报的依据，请确<br/>认是否继续进行统计确认？</div>
      </div>
  );
  ElMessageBox.alert(vnode, '提示', {
    cancelButtonText: '取消',
    showCancelButton: true,
    customClass: 'statist-confirm-pop-713',
  })
      .then(() => {
        $emit('exeSaveQa', {type: 3}) // 统计确认
      })
      .catch(() => {
      })
}

//撤销确认
function revokeConfirm() {
  $emit('exeSaveQa', {type: 4}) // 撤销确认
}

function revokeStatist() {
  const vnode = (
      <div
          style="color:#555555;line-height:22px;letter-spacing: 0.3px;display:flex;flex-direction: column; align-items: center;width:400px;">
        <img style="display:block;width:32px;height:32px;" src="https://static.rhkj.com/renhe_fe/other/334.png"></img>
        <div style="font-size: 20px;">撤销统计</div>
        <br/>
        <div>是否确定进行操作？</div>
      </div>
  );
  ElMessageBox.alert(vnode, '提示', {
    cancelButtonText: '取消',
    showCancelButton: true,
  })
      .then(() => {
        currentStep.value = 0
      })
      .catch(() => {
      })
}

function initResDataShow() {
  summaryList.value = [
    {
      jxlx: '本期认证相符的增值税专用发票（第2行）',
      fs: pageShowVal.value.fs,
      je: pageShowVal.value.amountTotal,
      sx: pageShowVal.value.taxAmountTotal,
    },
    {
      jxlx: '海关进口增值税缴款书（第5行）',
      fs: '0',
      je: '-',
      sx: '0',
    },
    {
      jxlx: '农产品收购发票或者销售发票（第6行）',
      fs: '0',
      je: '0',
      sx: '0',
    },
    {
      jxlx: '代扣代缴税收缴款凭证（第7行）',
      fs: '0',
      je: '0',
      sx: '0',
    },
    {
      jxlx: '加计扣除农产品进项税额（第8a行）',
      fs: '0',
      je: '0',
      sx: '0',
    },
    {
      jxlx: '外贸企业进项税额抵扣证明（第11行）',
      fs: '0',
      je: '0',
      sx: '0',
    },
  ]
  statistResList.value = [
    {
      fplx: '增值税专用发票',
      hjfs: pageShowVal.value.fs,
      yxhj: pageShowVal.value.effectiveTaxAmountTotal,
      ckfs: '0',
      ckhj: '0',
      qtfs: pageShowVal.value.fs,
      qthj: pageShowVal.value.effectiveTaxAmountTotal,
    },
    {
      fplx: '收购发票',
      hjfs: '0',
      yxhj: '0',
      ckfs: '--',
      ckhj: '--',
      qtfs: '0',
      qthj: '0',
    },
    {
      fplx: '免税自产农产品普通发票',
      hjfs: '0',
      yxhj: '0',
      ckfs: '--',
      ckhj: '--',
      qtfs: '0',
      qthj: '0',
    },
    {
      fplx: '通行费发票',
      hjfs: '0',
      yxhj: '0',
      ckfs: '--',
      ckhj: '--',
      qtfs: '0',
      qthj: '0',
    },
    {
      fplx: '其他普通发票',
      hjfs: '0',
      yxhj: '0',
      ckfs: '--',
      ckhj: '--',
      qtfs: '0',
      qthj: '0',
    },
    {
      fplx: '机动车统一销售发票',
      hjfs: '0',
      yxhj: '0',
      ckfs: '--',
      ckhj: '--',
      qtfs: '0',
      qthj: '0',
    },
    {
      fplx: '海关缴款书',
      hjfs: '0',
      yxhj: '0',
      ckfs: '0',
      ckhj: '0',
      qtfs: '0',
      qthj: '0',
    },
    {
      fplx: '代扣代缴完税凭证',
      hjfs: '0',
      yxhj: '0',
      ckfs: '--',
      ckhj: '--',
      qtfs: '0',
      qthj: '0',
    },
    {
      fplx: '合计',
      hjfs: pageShowVal.value.fs,
      yxhj: pageShowVal.value.effectiveTaxAmountTotal,
      ckfs: '0',
      ckhj: '0',
      qtfs: pageShowVal.value.fs,
      qthj: pageShowVal.value.effectiveTaxAmountTotal,
    },
  ]
}

// 页面可能展示的统计值。
const pageShowVal = computed(() => {
  const data = {
    checkRows: [],
    verify: '否',
    ...JSON.parse(props.currentQa?.solution || "{}")
  }
  let amountTotal = new Big(0), taxAmountTotal = new Big(0), effectiveTaxAmountTotal = new Big(0)
  data.checkRows.forEach(row => {
    amountTotal = amountTotal.plus(row.amount) //金额合计
    taxAmountTotal = taxAmountTotal.plus(row.taxAmount) //税额合计
    effectiveTaxAmountTotal = effectiveTaxAmountTotal.plus(row.effectiveTaxAmount) // 有效税额合计
  })

  return {
    amountTotal: amountTotal.toFixed(2),
    taxAmountTotal: taxAmountTotal.toFixed(2),
    effectiveTaxAmountTotal: effectiveTaxAmountTotal.toFixed(2),
    fs: data.checkRows.length, //份数
  }
})

</script>


<style scoped lang="scss">
.pag-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;

  .content-box {
    flex-grow: 1;
    background-color: #f2f2f2;
    box-sizing: border-box;
    padding: 20px 40px;
    overflow-y: auto;

    .title-header {
      display: flex;
      align-items: center;
      padding: 22px 20px 22px 20px;
      background-color: #FFFFFF;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

      > h3 {
        font-size: 16px;
        font-weight: 700;
      }

      > span.sub {
        margin-left: 20px;
        font-weight: 400;
        color: #999;
      }
    }

    .label-title {
      position: relative;

      .status-show {
        position: absolute;
        top: -10px;
        right: -75px;
        color: #fff;
        height: 30px;
        box-sizing: border-box;
        line-height: 20px;
        background-color: #f56c6c;
        padding: 5px;
        font-size: 12px;
        border-radius: 21px 20px 20px 0;
      }
    }

    .statist-wrap {
      padding: 0 30px;

      .step0 {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .step2 {

        > h3 {
          font-weight: 700;
          font-size: 20px;
          line-height: 40px;
          color: #000;
        }

        :deep(.summary-ui-table) {
          .el-table__header {
            th.el-table__cell {
              background-color: rgb(247, 253, 255);
              color: #000;
              font-weight: 700;
              font-size: 16px;
              padding: 12px 0;

              .cell {
                font-weight: inherit;
              }
            }
          }

          .el-table__body {
            td.el-table__cell {
              padding: 15px 0;

              .cell {
                color: #000;
                font-size: 16px;
              }
            }
          }
        }
      }
    }

  }

  .bottom {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<style lang="scss">
.statist-confirm-pop-713 {
  width: 315px;
  padding-left: 20px;
  padding-right: 20px;
  .el-message-box__header {
    padding-bottom: 20px;
    .el-message-box__title {
      text-align: center;
    }
  }
  .el-message-box__btns {
    justify-content: center;
  }
}
</style>
